export default function TeamFonts() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Fonts Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
